import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Link,
  Alert,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useIntl } from "react-intl";
import { signIn, fetchCompany } from "../../api/companyApi";
import { useAuth } from "../../providers/AuthProvider";
import { resolveBackendErrorKey } from "../../utils/backendErrors";

export default function SignInPage() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { login } = useAuth();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    companyDomainName: "",
    companyPassword: "",
    eaName: "",
    eaPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
      const res = await signIn(form);
      const companyId = res.returnValue;
      const company = await fetchCompany(companyId);
      login(companyId, company, form.eaName);
      navigate("/", { replace: true });
    } catch (err) {
      setErrorMsg(t(resolveBackendErrorKey(err.message, "auth.error.signin")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          mt: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: "secondary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
          }}
        >
          <LockOutlinedIcon sx={{ color: "white" }} />
        </Box>
        <Typography component="h1" variant="h5" gutterBottom>
          {t("auth.signin.title")}
        </Typography>

        <Paper sx={{ p: 4, width: "100%", mt: 2 }}>
          {errorMsg && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMsg}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label={t("auth.company.domainName")}
              name="companyDomainName"
              value={form.companyDomainName}
              onChange={handleChange}
              fullWidth
              required
              autoFocus
              margin="normal"
            />
            <TextField
              label={t("auth.company.password")}
              name="companyPassword"
              type="password"
              value={form.companyPassword}
              onChange={handleChange}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label={t("auth.ea.email")}
              name="eaName"
              type="email"
              value={form.eaName}
              onChange={handleChange}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label={t("auth.ea.password")}
              name="eaPassword"
              type="password"
              value={form.eaPassword}
              onChange={handleChange}
              fullWidth
              required
              margin="normal"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{ mt: 3, mb: 2 }}
            >
              {t("auth.signin.title")}
            </Button>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Link component={RouterLink} to="/signup" variant="body2">
              {t("auth.signup.link")}
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
